import { createConstants } from '../utils/helpers';

export default createConstants(
  'LOGIN_USER_REQUEST',
  'LOGIN_USER_FAILURE',
  'LOGIN_USER_SUCCESS',
  'LOGOUT_USER',

  'FETCH_USERS_REQUEST',
  'FETCH_USERS_FAILURE',
  'FETCH_USERS_SUCCESS',

  'CREATE_USER_REQUEST',
  'CREATE_USER_FAILURE',
  'CREATE_USER_SUCCESS',

  'UPDATE_USER_REQUEST',
  'UPDATE_USER_FAILURE',
  'UPDATE_USER_SUCCESS',

  'FETCH_USER_REQUEST',
  'FETCH_USER_FAILURE',
  'FETCH_USER_SUCCESS',

  'RESET_PASSWORD_REQUEST',
  'RESET_PASSWORD_FAILURE',
  'RESET_PASSWORD_SUCCESS',

  'FETCH_ENTRIES_REQUEST',
  'FETCH_ENTRIES_FAILURE',
  'FETCH_ENTRIES_SUCCESS',

  'CREATE_ENTRY_REQUEST',
  'CREATE_ENTRY_FAILURE',
  'CREATE_ENTRY_SUCCESS',

  'EDIT_ENTRY_REQUEST',
  'EDIT_ENTRY_SUCCESS',
  'EDIT_ENTRY_FAILURE',

  'DELETE_ENTRY_REQUEST',
  'DELETE_ENTRY_FAILURE',
  'DELETE_ENTRY_SUCCESS',

  'FETCH_HORSES_REQUEST',
  'FETCH_HORSES_FAILURE',
  'FETCH_HORSES_SUCCESS',

  'FETCH_VAULTERS_REQUEST',
  'FETCH_VAULTERS_FAILURE',
  'FETCH_VAULTERS_SUCCESS',

  'ADD_VAULTER_REQUEST',
  'ADD_VAULTER_FAILURE',
  'ADD_VAULTER_SUCCESS',

  'FETCH_LUNGERS_REQUEST',
  'FETCH_LUNGERS_FAILURE',
  'FETCH_LUNGERS_SUCCESS',

  'ADD_LUNGER_REQUEST',
  'ADD_LUNGER_FAILURE',
  'ADD_LUNGER_SUCCESS',

  'FETCH_NATION_HORSES_REQUEST',
  'FETCH_NATION_HORSES_SUCCESS',
  'FETCH_NATION_HORSES_FAILURE',

  'ADD_HORSE_REQUEST',
  'ADD_HORSE_SUCCESS',
  'ADD_HORSE_FAILURE',

  'FETCH_ADDITIONAL_HORSES_REQUEST',
  'FETCH_ADDITIONAL_HORSES_FAILURE',
  'FETCH_ADDITIONAL_HORSES_SUCCESS',

  'CREATE_ADDITIONAL_HORSE_REQUEST',
  'CREATE_ADDITIONAL_HORSE_FAILURE',
  'CREATE_ADDITIONAL_HORSE_SUCCESS',

  'EDIT_ADDITIONAL_HORSE_REQUEST',
  'EDIT_ADDITIONAL_HORSE_SUCCESS',
  'EDIT_ADDITIONAL_HORSE_FAILURE',

  'DELETE_ADDITIONAL_HORSE_REQUEST',
  'DELETE_ADDITIONAL_HORSE_FAILURE',
  'DELETE_ADDITIONAL_HORSE_SUCCESS',

  'FETCH_NATIONS_REQUEST',
  'FETCH_NATIONS_FAILURE',
  'FETCH_NATIONS_SUCCESS',

  'FETCH_FEI_ID_REQUEST',
  'FETCH_FEI_ID_SUCCESS',
  'FETCH_FEI_ID_FAILURE'
);



// WEBPACK FOOTER //
// ./src/constants/index.js